<template lang="pug">
v-layout#ly_constancy_registered(align-center wrap)
  v-flex(xs2 sm12 md3 lg3)
  v-flex.cr-main.text-xs-center.text-md-center(xs12 sm12 md6 lg6)
    img.img-solicitud_registrada(:src="successIcon")
    h2.omnesMedium.text-xs-center.text-md-center.title-solicitud 
      | ¡Tu solicitud de anulación de póliza{{ requestNumber ? ` N° ${requestNumber}` : '' }} fue registrada con éxito!
    p.omnesRegular.text-xs-center.text-md-center.subtitle-solicitud
      | En un <b>plazo máximo de 7 días hábiles</b>, procesaremos tu solicitud y te enviaremos el resultado al correo electrónico registrado.
    
    v-layout.detalle-cambio
      v-flex(xs12 sm12 md12 lg12)
        v-layout
          v-flex(xs5 sm6 md7 lg7)
            p.label-resumen Número de póliza:
          v-flex(xs7 sm6 md5 lg5)
            p.text-resumen {{ policy }}
        v-layout
          v-flex(xs5 sm6 md7 lg7)
            p.label-resumen Producto:
          v-flex(xs7 sm6 md5 lg5)
            p.text-resumen {{ product }}
        v-layout
          v-flex(xs5 sm6 md7 lg7)
            p.label-resumen Motivo de anulación:
          v-flex(xs7 sm6 md5 lg5)
            p.text-resumen {{ cancellationReason }}


    .disclaimer-endosos
      p.omnesRegular
        img.img-disclaimer(:src="clockIcon" style="width: 16px; height: 16px; vertical-align: middle; margin-right: 10px")
        span(style="color: #6e6e6e; font-size: 14px; text-align: justify;") Si corresponde, la devolución de la prima por el periodo no transcurrido se realizará como parte de este mismo proceso.

    .btns-actions
      v-btn#btnBackToMain.omnesSemibold(type='button' @click="$emit('go-home')") Ir al menú principal


  v-flex(xs2 sm12 md3 lg3)
</template>

<script>
/**
 * @component StepSOATCancellationSuccess
 * @description Pantalla de confirmación exitosa de anulación de póliza SOAT.
 * Muestra mensaje de éxito y resumen de la solicitud procesada.
 * 
 * @example
 * <StepSOATCancellationSuccess
 *   request-number="12345"
 *   policy="123456789"
 *   product="SOAT"
 *   cancellation-reason="Ya no tengo el vehículo"
 *   @go-home="navigateToHome"
 * />
 */
export default {
  name: 'StepSOATCancellationSuccess',
  props: {
    requestNumber: {
      type: [String, Number],
      required: false,
      default: null
    },
    policy: {
      type: String,
      required: true
    },
    product: {
      type: String,
      required: true
    },
    cancellationReason: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      successIcon: require('@/assets/formpp/icon_registered_request.svg'),
      clockIcon: require('@/assets/formpp/icon_load_gray.svg')
    }
  }
}
</script>

<style scoped>
#ly_constancy_registered {
  padding: 40px 0;
}

.cr-main {
  border: 1px solid #DADADA;
  border-radius: 8px;
  padding: 24px 20px;
  background: #FFF;
  max-width: 450px;
  margin: 0 auto;
}

.img-solicitud_registrada {
  margin: 0 auto 16px;
  display: block;
}

.title-solicitud {
  font-family: 'Omnes Medium';
  font-size: 18px;
  color: #0855C4;
  margin-bottom: 10px;
  line-height: 1.4;
}

.subtitle-solicitud {
  font-family: 'Omnes Regular';
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 16px;
  padding: 0 20px;
}

#ly_constancy_registered .btns-actions {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 0rem;
}

#ly_constancy_registered .detalle-cambio {
  margin-top: 20px;
  margin-left: -5px;
  margin-right: -5px;
  background: #F9F9F9;
  border: none;
  border-top: 2px dashed #DADADA;
  border-bottom: 2px dashed #DADADA;
  border-radius: 0;
  padding: 16px 20px;
}

#ly_constancy_registered .detalle-cambio .v-layout {
  margin-bottom: 10px;
}

#ly_constancy_registered .detalle-cambio .v-layout:last-child {
  margin-bottom: 0;
}

#ly_constancy_registered .label-resumen {
  font-family: 'Omnes Regular';
  font-size: 13px;
  color: #454A6C;
  margin: 0;
  text-align: left;
}

#ly_constancy_registered .text-resumen {
  font-family: 'Omnes Medium';
  font-size: 13px;
  color: #454A6C;
  font-weight: 600;
  margin: 0;
  text-align: right;
}

#btnBackToMain {
  background: #EA0D90 !important;
  color: #FFF !important;
  padding: 0 !important;
  border-radius: 4px;
  text-transform: none;
  font-size: 14px;
  margin-top: 20px;
  box-shadow: none !important;
  /* height: 56px !important; */
  width: 90% !important;
}

#btnBackToMain:hover {
  background: #D10C80 !important;
}

.disclaimer-endosos {
  margin-top: 20px;
  /* margin-left: -10px; */
  /* margin-right: -10px; */
  margin-bottom: 0px;
  padding: 12px 20px;
  background: #F9F9F9;
  border-radius: 0 0 6px 6px;
  font-size: 13px;
  color: #666;
  text-align: center;
  border: 1px solid #DADADA;
  
}

.disclaimer-endosos p {
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
}

.disclaimer-endosos .img-disclaimer {
  display: inline-block;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/soat/StepSOATCancellationSuccess.vue